module.exports = __webpack_public_path__ + "MINI-logo.png";